import * as React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from '../../components/Helmet';
import { selectMarkedListSchema } from '../../selectors/seo';

export const HelmetContainer = () => {
  const schema = useSelector(selectMarkedListSchema);

  if (!schema) {
    return null;
  }

  const scripts = [{ content: schema, attrs: { type: 'application/ld+json' } }];

  return <Helmet scripts={scripts} />;
};
